export default {
    namespaced: true,
    state () {
        return {
            authenticated: false,
            type: "guest",
            user: {},
        }
    },
    mutations: {
        setUser (state, user) {
            state.user = user;
            if(typeof user.id !== 'undefined')
                state.type = 'user';
            state.authenticated = true;
        },
    },
    getters: {
        username (state) {
            if (typeof state.user.name !== 'undefined' && state.user.name) {
                return state.user.name;
            }
            return '#'+state.user.id;
        },
        isLoggedIn(state) {
            return state.type === 'user' && !!state.user?.id;
        }
    }
}
